

import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box, Typography, Card, CardContent, Button, IconButton,
  Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Dialog, DialogContent, DialogActions, TextField,DialogTitle,
  Select, MenuItem, FormControl, InputLabel,
  Alert, Snackbar, Tooltip, Grid,
  Stack, InputAdornment, useMediaQuery, useTheme as useMuiTheme,
  Divider, Container, Pagination, CircularProgress,Badge,Avatar,
  ToggleButtonGroup,ToggleButton,ListItemText,ListItem,List,ListItemIcon
} from "@mui/material";
import { ThemeProvider, alpha } from "@mui/material/styles";
import Fade from "@mui/material/Fade";
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Download as DownloadIcon,
  Search as SearchIcon,
  Refresh as RefreshIcon,
  TaskAlt as TaskAltIcon,
  CalendarMonth as CalendarMonthIcon,
  Close as CloseIcon,
  BookOnline as BookOnlineIcon,
  MedicalServices as MedicalServicesIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  LocationOn as LocationOnIcon,
  Visibility as VisibilityIcon,
  Event as EventIcon,
  Schedule as ScheduleIcon,
  Dashboard as DashboardIcon,
  PersonAdd as PersonAddIcon,
  AccessTime as AccessTimeIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  Notes as NotesIcon,
  CurrencyRupee as CurrencyRupeeIcon,
  PaymentOutlined as PaymentIcon,
  
} from "@mui/icons-material";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import axios from 'axios' 
import ClearIcon from "@mui/icons-material/Clear";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
// ─── Import shared utilities from Services file ───────────────────────────────
import { adminTheme, CAT_META, authHeader, CatChip, PaginationBar } from "./Nursingphysioservicesadmin";
import { registerFetchedOrders, isOrderUnseen, markOrderSeen } from '../../utils/orderNotifications';
const MOBILE_BAR_H = 56;
const API          = process.env.REACT_APP_API;

// ─── Status config ────────────────────────────────────────────────────────────
const STATUS_CFG = {
  pending:   { label: "Pending",   color: "warning", bg: "#FEF3C7", text: "#D97706" },
  confirmed: { label: "Confirmed", color: "info",    bg: "#DBEAFE", text: "#2563EB" },
  completed: { label: "Completed", color: "success", bg: "#D1FAE5", text: "#059669" },
  cancelled: { label: "Cancelled", color: "error",   bg: "#FEE2E2", text: "#DC2626" },
};

const StatusChip = ({ value }) => {
  const c = STATUS_CFG[value] || { label: value, color: "default" };
  return <Chip label={c.label} size="small" color={c.color} sx={{ fontWeight: 700, fontSize: 11 }} />;
};


// ─── Payment config ───────────────────────────────────────────────────────────

const PAYMENT_CFG = {
  unpaid:  { label: "Unpaid",      bg: "#FEE2E2", text: "#DC2626" },
  pending: { label: "Pay Pending", bg: "#FEF3C7", text: "#D97706" },
  paid:    { label: "Paid ✓",      bg: "#D1FAE5", text: "#059669" },
};

const PaymentChip = ({ value, paymentId }) => {
  const c = PAYMENT_CFG[value || "unpaid"];
  // Show "Cash Paid" label if payment_id is CASH
  const label = (value === "paid" && paymentId === "CASH") ? " Cash Paid" : c.label;
  return (
    <Chip label={label} size="small"
      sx={{ bgcolor: c.bg, color: c.text, fontWeight: 700, fontSize: 10, height: 20 }} />
  );
};

// ─── Stat Card ────────────────────────────────────────────────────────────────
const StatCard = ({ label, value, icon, gradient, sub }) => (
  <Card sx={{ overflow: "hidden", position: "relative" }}>
    <Box sx={{ height: 4, background: gradient }} />
    <CardContent sx={{ p: { xs: 1.5, sm: 2, md: 2.5 } }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box>
          <Typography variant="caption" color="text.secondary" fontWeight={700}
            textTransform="uppercase" letterSpacing={0.6} display="block">
            {label}
          </Typography>
          <Typography sx={{
            fontFamily: "'Sora',sans-serif", fontWeight: 900, mt: 0.3,
            fontSize: { xs: 24, sm: 28, md: 34 }, lineHeight: 1,
            background: gradient, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          }}>
            {value}
          </Typography>
          {sub && <Typography variant="caption" color="text.secondary" mt={0.4} display="block">{sub}</Typography>}
        </Box>
        <Box sx={{
          width: { xs: 38, sm: 46 }, height: { xs: 38, sm: 46 }, borderRadius: 2.5,
          background: gradient, display: "flex", alignItems: "center", justifyContent: "center",
          color: "#fff", flexShrink: 0, boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}>
          {icon}
        </Box>
      </Box>
    </CardContent>
  </Card>
);

// ─── Booking Mobile Card ──────────────────────────────────────────────────────
const BookingMobileCard = ({ b, onStatus, onView, onAssign, onComplete, onSetAmount,onCashPaid,onUploadAgreement}) => {
  const meta = CAT_META[b.category] || CAT_META.nursing;
  return (
    <Card sx={{ overflow: "hidden", mb: 1.5 }}>
      <Box sx={{ height: 4, background: meta.gradient }} />
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
          <Box>
            <Typography fontWeight={800} fontSize={14} sx={{ fontFamily: "'Sora',sans-serif" }}>
              {b.patient_name}
            </Typography>
            <Typography variant="caption" sx={{ fontFamily: "monospace", color: meta.accent, fontWeight: 700 }}>
              {b.booking_ref}
            </Typography>
          </Box>
          <StatusChip value={b.status} />
        </Box>

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 1.25 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <PhoneIcon sx={{ fontSize: 13, color: "text.secondary" }} />
            <Typography variant="caption" fontWeight={600}>{b.patient_phone}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <CalendarMonthIcon sx={{ fontSize: 13, color: "text.secondary" }} />
            <Typography variant="caption" fontWeight={600}>{b.start_date && b.end_date
    ? `${b.start_date} → ${b.end_date}`
    : b.scheduled_date}
  {" · "}
  {b.scheduled_time}</Typography>
          </Box>
        </Box>

        <Typography fontSize={13} fontWeight={600} mb={0.5}>{b.service_name}</Typography>
        <CatChip value={b.category} />

        {/* Assigned staff badge */}
        {b.assigned_staff_name && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.75,
            bgcolor: alpha("#7c3aed", 0.08), px: 1, py: 0.5, borderRadius: 1.5, width: "fit-content" }}>
            <PersonIcon sx={{ fontSize: 12, color: "#7c3aed" }} />
            <Typography variant="caption" fontWeight={700} sx={{ color: "#7c3aed" }}>
              {b.assigned_staff_name}
            </Typography>
          </Box>
        )}

        {b.patient_address && (
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5, mt: 0.75 }}>
            <LocationOnIcon sx={{ fontSize: 13, color: "text.secondary", mt: 0.15, flexShrink: 0 }} />
            <Typography variant="caption" color="text.secondary">{b.patient_address}</Typography>
          </Box>
        )}

        <Button size="small" variant="outlined" fullWidth startIcon={<VisibilityIcon sx={{ fontSize: 14 }} />}
          onClick={() => onView(b)}
          sx={{ mt: 1.5, borderColor: meta.accent, color: meta.accent, borderRadius: 2, fontWeight: 700, fontSize: 12,
            "&:hover": { bgcolor: alpha(meta.accent, 0.06) } }}>
          View Full Details
        </Button>

        <Button size="small" variant="outlined" fullWidth startIcon={<AssignmentTurnedInIcon sx={{ fontSize: 14 }} />}
          onClick={() => onUploadAgreement(b)}
          sx={{ mt: 1, borderColor: "#006D77", color: "#006D77", borderRadius: 2, fontWeight: 700, fontSize: 12 }}>
          {b.agreement ? "Replace Agreement" : "Upload Agreement"}
        </Button>

        {/* Action buttons */}
        {(b.status === "pending" || b.status === "confirmed") && (
          <Button size="small" variant="outlined" fullWidth startIcon={<PersonAddIcon sx={{ fontSize: 14 }} />}
            onClick={() => onAssign(b)}
            sx={{ mt: 1, borderColor: "#7c3aed", color: "#7c3aed", borderRadius: 2, fontWeight: 700, fontSize: 12 }}>
            {b.assigned_staff_name ? `Reassign (${b.assigned_staff_name})` : "Assign Staff"}
          </Button>
        )}

        {b.status === "pending" && (
          <Stack direction="row" spacing={1} mt={1}>
            <Button size="small" variant="contained" color="success" startIcon={<CheckCircleIcon />}
              onClick={() => onStatus(b._id, "confirmed")} fullWidth>Confirm</Button>
            <Button size="small" variant="outlined" color="error" startIcon={<CancelIcon />}
              onClick={() => onStatus(b._id, "cancelled")} fullWidth>Cancel</Button>
          </Stack>
        )}

        {b.status === "confirmed" && (
          <Button size="small" variant="contained" color="success" startIcon={<TaskAltIcon />}
            onClick={() => onComplete(b)} fullWidth sx={{ mt: 1 }}>
            Mark Completed
          </Button>
        )}

        {b.status === "completed" && b.payment_status !== "paid" && (
          <Button size="small" variant="contained" fullWidth
            startIcon={<PaymentIcon sx={{ fontSize: 14 }} />}
            onClick={() => onSetAmount(b)}
            sx={{ mt: 1, bgcolor: "#16a34a", fontWeight: 700, fontSize: 12, borderRadius: 2,
              "&:hover": { bgcolor: "#166534" } }}>
            Set Online Amount
          </Button>
        )}
        {b.status === "completed" && b.payment_status !== "paid" && (
          <Button size="small" variant="contained" fullWidth
            startIcon={<CurrencyRupeeIcon sx={{ fontSize: 14 }} />}
            onClick={() => onCashPaid(b)}
            sx={{ mt: 1, bgcolor: "#d97706", fontWeight: 700, fontSize: 12, borderRadius: 2,
              "&:hover": { bgcolor: "#b45309" } }}>
            Mark Cash Paid
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

// ─── Booking View Dialog ──────────────────────────────────────────────────────
const BookingViewDialog = ({ booking, onClose, onStatus, onAssign, onComplete ,onUploadAgreement,onViewDocument,onUpdateSession,onAddSession}) => {
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  if (!booking) return null;

  const meta        = CAT_META[booking.category] || CAT_META.nursing;
  const canConfirm  = booking.status === "pending";
  const canCancel   = ["pending", "confirmed"].includes(booking.status);
  const canComplete = booking.status === "confirmed";
  const canAssign   = ["pending", "confirmed"].includes(booking.status);
  const handleInvoiceDownload=async(order_id)=>{
    try {
          const token = sessionStorage.getItem("token");

          const response = await axios.get(
            `${process.env.REACT_APP_API_INVOICE}/nursing-invoice/download/${order_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const download_url=response.data.download_url
          window.open(download_url, "_blank");
        } catch (error) {
          console.error("Invoice download failed:", error);
        }
}


  const InfoRow = ({ icon, label, value }) => (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, px: 2.5, py: 1.25, borderBottom: "1px solid #f1f5f9" }}>
      <Box sx={{ color: meta.accent, mt: 0.2, "& svg": { fontSize: 16 } }}>{icon}</Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="caption" fontWeight={700} textTransform="uppercase"
          letterSpacing={0.5} color="text.secondary" fontSize={9.5} display="block">
          {label}
        </Typography>
        <Typography fontSize={13} fontWeight={600} color="text.primary" sx={{ wordBreak: "break-word" }}>
          {value || "—"}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Dialog open={!!booking} onClose={onClose} maxWidth="sm" fullWidth
      fullScreen={isMobile} TransitionComponent={Fade}
      PaperProps={{ sx: { borderRadius: isMobile ? 0 : 3, overflow: "hidden" } }}>

      {/* Gradient header */}
      <Box sx={{ background: meta.gradient, px: 3, py: 2.5, position: "relative", overflow: "hidden" }}>
        <Box sx={{ position: "absolute", top: -40, right: -40, width: 150, height: 150, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.08)" }} />
        <Box sx={{ position: "absolute", bottom: -30, left: -20, width: 110, height: 110, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.06)" }} />
        <Box sx={{ position: "relative", zIndex: 1, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Box>
            <Typography sx={{ fontSize: 32, lineHeight: 1, mb: 0.75 }}>{meta.emoji}</Typography>
            <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: { xs: 15, sm: 18 }, mb: 0.4 }}>
              {booking.service_name}
            </Typography>
            <Box sx={{ display: "inline-block", bgcolor: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 12, fontWeight: 800, px: 1.5, py: 0.3, borderRadius: 1.5, fontFamily: "monospace", mb: 1 }}>
              {booking.booking_ref}
            </Box>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
              <Box sx={{ bgcolor: "rgba(255,255,255,0.18)", color: "#fff", fontSize: 11, fontWeight: 700, px: 1.25, py: 0.3, borderRadius: 10, textTransform: "capitalize" }}>
                {booking.category}
              </Box>
              {(() => {
                const sc = STATUS_CFG[booking.status] || {};
                return <Box sx={{ bgcolor: sc.bg, color: sc.text, fontSize: 11, fontWeight: 800, px: 1.25, py: 0.3, borderRadius: 10 }}>{sc.label}</Box>;
              })()}
            </Box>
          </Box>
          <IconButton onClick={onClose} size="small"
            sx={{ color: "#fff", bgcolor: "rgba(255,255,255,0.15)", "&:hover": { bgcolor: "rgba(255,255,255,0.25)" }, flexShrink: 0 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      <DialogContent sx={{ p: 0 }}>
        {/* Patient details section */}
        <Box sx={{ px: 2.5, pt: 2, pb: 0.5 }}>
          <Typography sx={{ fontSize: 10, fontWeight: 800, color: meta.accent, textTransform: "uppercase", letterSpacing: 0.6 }}>
            Patient Details
          </Typography>
        </Box>
        <InfoRow icon={<PersonIcon />}     label="Patient Name"   value={booking.patient_name} />
        <InfoRow icon={<PhoneIcon />}      label="Phone Number"   value={booking.patient_phone} />
        <InfoRow icon={<LocationOnIcon />} label="Home Address"   value={booking.patient_address} />

        {/* Appointment section */}
        <Box sx={{ px: 2.5, pt: 2, pb: 0.5 }}>
          <Typography sx={{ fontSize: 10, fontWeight: 800, color: meta.accent, textTransform: "uppercase", letterSpacing: 0.6 }}>
            Appointment
          </Typography>
        </Box>
        <InfoRow icon={<EventIcon />}          label="Scheduled Date" value={
                                                                      booking.start_date && booking.end_date
                                                                        ? `${booking.start_date} → ${booking.end_date}`
                                                                        : booking.scheduled_date
                                                                    } />
        <InfoRow icon={<ScheduleIcon />}       label="Time Slot"      value={booking.scheduled_time} />
        <InfoRow icon={<MedicalServicesIcon />} label="Service"       value={booking.service_name} />
        {booking.invoice &&(<Button
            variant="contained"
            size="small"
            startIcon={<DownloadIcon />}
            onClick={() => {
              handleInvoiceDownload(booking.booking_ref)
            }}
            sx={{ 
              bgcolor: '#006D77', 
              '&:hover': { bgcolor: '#005560' },
              textTransform: 'none',
              marginLeft:"8px"
            }}
          >
            Download Invoice
          </Button>)}
          {booking.agreement && (
          <Button
            variant="outlined" size="small" startIcon={<DownloadIcon />}
            href={booking.agreement.url} target="_blank"
            sx={{ ml: 1, borderColor: "#006D77", color: "#006D77" }}
          >
            View Signed Agreement
          </Button>
        )}

        {booking.document_urls?.length > 0 && (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
            {booking.document_urls.map((url, i) => (
              <Button
                key={i}
                variant="outlined" size="small" startIcon={<VisibilityIcon />}
                onClick={() => onViewDocument(url)}
                sx={{ borderColor: "#006D77", color: "#006D77" }}
              >
                Patient Document {i + 1}
              </Button>
            ))}
          </Box>
        )}


        {/* Assigned staff section — shown only if assigned */}
        {booking.assigned_staff_name && (
          <>
            <Box sx={{ px: 2.5, pt: 2, pb: 0.5 }}>
              <Typography sx={{ fontSize: 10, fontWeight: 800, color: "#7c3aed", textTransform: "uppercase", letterSpacing: 0.6 }}>
                Assigned Staff
              </Typography>
            </Box>
            <InfoRow icon={<PersonIcon />} label="Staff Name"  value={booking.assigned_staff_name} />
            <InfoRow icon={<PhoneIcon />}  label="Staff Phone" value={booking.assigned_staff_phone} />
          </>
        )}
       {/* Sessions — physiotherapy only */}
            {booking.category === "physiotherapy" && (
          <>
            <Box sx={{ px: 2.5, pt: 2, pb: 0.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography sx={{ fontSize: 10, fontWeight: 800, color: "#16a34a", textTransform: "uppercase", letterSpacing: 0.6 }}>
                Sessions ({booking.sessions?.filter(s => s.status === "completed").length || 0}/{booking.sessions?.length || 0} completed)
              </Typography>
              <Button size="small" variant="outlined" startIcon={<PersonAddIcon sx={{ fontSize: 14 }} />}
                onClick={() => onAddSession(booking)}
                sx={{ fontSize: 11, borderColor: "#7c3aed", color: "#7c3aed", py: 0.25 }}>
                Add Session
              </Button>
            </Box>
            {booking.sessions.map((s) => {
              const sessCfg = {
                scheduled: { bg: "#DBEAFE", text: "#2563EB", label: "Scheduled" },
                completed: { bg: "#D1FAE5", text: "#059669", label: "Completed" },
                missed:    { bg: "#FEE2E2", text: "#DC2626", label: "Missed" },
                cancelled: { bg: "#F1F5F9", text: "#64748B", label: "Cancelled" },
              }[s.status];
              return (
                <Box key={s.session_id} sx={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  px: 2.5, py: 1, borderBottom: "1px solid #f1f5f9",
                }}>
                  <Box>
                    <Typography fontSize={13} fontWeight={700}>{s.session_date}</Typography>
                    {s.notes && <Typography fontSize={11} color="text.secondary">{s.notes}</Typography>}
                    {s.time_taken_minutes && (
                      <Typography fontSize={11} color="text.secondary">
                        ⏱ {s.time_taken_minutes} mins
                      </Typography>
                    )}
                  </Box>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Box sx={{ bgcolor: sessCfg.bg, color: sessCfg.text, fontSize: 11, fontWeight: 800, px: 1.25, py: 0.3, borderRadius: 10 }}>
                      {sessCfg.label}
                    </Box>
                    {/* {s.status === "scheduled" && ( */}
                    
                      <Button size="small" variant="outlined"
                        onClick={() => onUpdateSession(booking, s)}
                        sx={{ fontSize: 11, borderColor: "#16a34a", color: "#16a34a" }}>
                        Update
                      </Button>
                    {/* )} */}
                  </Stack>
                </Box>
              );
            })}
          </>
        )}
        {/* Completion details — shown only when completed */}
        {booking.status === "completed" && (
          <>
            <Box sx={{ px: 2.5, pt: 2, pb: 0.5 }}>
              <Typography sx={{ fontSize: 10, fontWeight: 800, color: "#16a34a", textTransform: "uppercase", letterSpacing: 0.6 }}>
                Completion Details
              </Typography>
            </Box>
            <InfoRow icon={<ScheduleIcon />}         label="Start Time"    value={booking.actual_start_time} />
            <InfoRow icon={<ScheduleIcon />}         label="End Time"      value={booking.actual_end_time} />
            <InfoRow icon={<AccessTimeIcon />}       label="Time Taken"    value={booking.time_taken_minutes ? `${booking.time_taken_minutes} mins` : "—"} />
            <InfoRow icon={<TaskAltIcon />}          label="Treatment"     value={booking.treatment_completed ? "✅ Completed Successfully" : "⚠️ Partially Completed"} />
            <InfoRow icon={<MedicalServicesIcon />}  label="Outcome Notes" value={booking.completion_notes} />
          </>
        )}

        {/* Notes */}
        {booking.notes && (
          <>
            <Box sx={{ px: 2.5, pt: 2, pb: 0.5 }}>
              <Typography sx={{ fontSize: 10, fontWeight: 800, color: meta.accent, textTransform: "uppercase", letterSpacing: 0.6 }}>Notes</Typography>
            </Box>
            <Box sx={{ px: 2.5, py: 1.25, bgcolor: alpha(meta.accent, 0.04), borderBottom: "1px solid #f1f5f9" }}>
              <Typography fontSize={13} color="text.secondary" lineHeight={1.7}>{booking.notes}</Typography>
            </Box>
          </>
        )}

        {booking.created_at && (
          <Box sx={{ px: 2.5, py: 1.25 }}>
            <Typography variant="caption" color="text.secondary" fontSize={11}>
              🕐 Booked on {new Date(booking.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <Divider />
      <DialogActions sx={{ px: 3, py: 2, gap: 1, flexWrap: "wrap" }}>
        {canAssign && (
          <Button variant="outlined" startIcon={<PersonAddIcon />}
            onClick={() => { onAssign(booking); onClose(); }}
            sx={{ fontWeight: 700, borderRadius: 2, borderColor: "#7c3aed", color: "#7c3aed",
              "&:hover": { bgcolor: alpha("#7c3aed", 0.06) } }}>
            {booking.assigned_staff_name ? "Reassign Staff" : "Assign Staff"}
          </Button>
        )}
        <Button variant="outlined" startIcon={<AssignmentTurnedInIcon />}
          onClick={() => { onUploadAgreement(booking); onClose(); }}
          sx={{ fontWeight: 700, borderRadius: 2, borderColor: "#006D77", color: "#006D77",
            "&:hover": { bgcolor: alpha("#006D77", 0.06) } }}>
          {booking.agreement ? "Replace Agreement" : "Upload Agreement"}
        </Button>
        {canConfirm && (
          <Button variant="contained" color="success" startIcon={<CheckCircleIcon />}
            onClick={() => { onStatus(booking._id, "confirmed"); onClose(); }}
            sx={{ fontWeight: 700, borderRadius: 2 }}>Confirm</Button>
        )}
        {canComplete && (
          <Button variant="contained" color="success" startIcon={<TaskAltIcon />}
            onClick={() => { onComplete(booking); onClose(); }}
            sx={{ fontWeight: 700, borderRadius: 2 }}>Mark Completed</Button>
        )}
        {canCancel && (
          <Button variant="outlined" color="error" startIcon={<CancelIcon />}
            onClick={() => { onStatus(booking._id, "cancelled"); onClose(); }}
            sx={{ fontWeight: 700, borderRadius: 2 }}>Cancel</Button>
        )}
        <Box sx={{ flex: 1 }} />
        <Button onClick={onClose} color="inherit" variant="outlined" sx={{ borderRadius: 2 }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

// ─── Assign Staff Dialog ──────────────────────────────────────────────────────
const AssignStaffDialog = ({ open, booking, onClose, onAssigned, notify }) => {
  const [staffList,     setStaffList]     = useState([]);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [loadingStaff,  setLoadingStaff]  = useState(false);
  const [saving,        setSaving]        = useState(false);

  useEffect(() => {
    if (!open || !booking) return;
    setSelectedStaff("");
    setLoadingStaff(true);
    fetch(`${API}/nursingphysiotherapy/admin/staff?category=${booking.category}`, { headers: authHeader() })
      .then(r => r.json())
      .then(d => { if (d.success) setStaffList(d.staff || []); })
      .catch(() => notify("Failed to load staff", "error"))
      .finally(() => setLoadingStaff(false));
  }, [open, booking]);

  const handleAssign = async () => {
    if (!selectedStaff) { notify("Please select a staff member", "warning"); return; }
    setSaving(true);
    try {
      const r = await fetch(`${API}/nursingphysiotherapy/admin/bookings/${booking._id}/assign`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify({ staff_id: selectedStaff }),
      });
      const d = await r.json();
      if (d.success) {
        notify("Staff assigned — email & SMS sent ✓");
        onAssigned();
        onClose();
      } else notify(d.error || "Failed to assign", "error");
    } catch { notify("Error assigning staff", "error"); }
    setSaving(false);
  };

  if (!booking) return null;
  const meta = CAT_META[booking.category] || CAT_META.nursing;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
      <Box sx={{ background: "linear-gradient(135deg, #7c3aed, #5b21b6)", px: 3, py: 2.5 }}>
        <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: 17 }}>
          👤 Assign Staff
        </Typography>
        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.65)", mt: 0.3 }}>
          {booking.service_name} · {booking.patient_name}
        </Typography>
        {booking.assigned_staff_name && (
          <Box sx={{ mt: 0.75, bgcolor: "rgba(255,255,255,0.15)", px: 1.5, py: 0.4, borderRadius: 1.5, width: "fit-content" }}>
            <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.9)", fontWeight: 700 }}>
              Currently: {booking.assigned_staff_name}
            </Typography>
          </Box>
        )}
      </Box>

      <Box sx={{ p: 3 }}>
        {loadingStaff ? (
          <Box sx={{ textAlign: "center", py: 3 }}>
            <CircularProgress size={28} sx={{ color: "#7c3aed" }} />
            <Typography fontSize={13} color="text.secondary" mt={1}>Loading staff…</Typography>
          </Box>
        ) : staffList.length === 0 ? (
          <Alert severity="warning" sx={{ borderRadius: 2 }}>
            No {booking.category} staff available. Add staff from the Staff Management section first.
          </Alert>
        ) : (
          <FormControl fullWidth size="small">
            <InputLabel>Select Staff Member</InputLabel>
            <Select value={selectedStaff} label="Select Staff Member"
              onChange={e => setSelectedStaff(e.target.value)}>
              {staffList.map(s => (
                <MenuItem key={s._id} value={s._id}>
                  <Box>
                    <Typography fontSize={13} fontWeight={700}>{s.name}</Typography>
                    <Typography fontSize={11} color="text.secondary">{s.phone} {s.email ? `· ${s.email}` : ""}</Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {selectedStaff && (
          <Alert severity="info" sx={{ mt: 2, borderRadius: 2, fontSize: 12 }}>
            Email & SMS will be sent to the selected staff member with booking details.
          </Alert>
        )}
      </Box>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button variant="contained" disabled={!selectedStaff || saving || loadingStaff}
          onClick={handleAssign}
          sx={{ background: "linear-gradient(135deg, #7c3aed, #5b21b6)", fontWeight: 700, px: 3 }}>
          {saving ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Assign & Notify"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ─── Completion Dialog ────────────────────────────────────────────────────────
const CompletionDialog = ({ open, booking, onClose, onCompleted, notify }) => {
  const [form,   setForm]   = useState({ actual_start_time: "", actual_end_time: "", time_taken_minutes: "", completion_notes: "", treatment_completed: true });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setForm({ actual_start_time: "", actual_end_time: "", time_taken_minutes: "", completion_notes: "", treatment_completed: true });
  }, [open]);

  const handleComplete = async () => {
    setSaving(true);
    try {
      const r = await fetch(`${API}/nursingphysiotherapy/admin/bookings/${booking._id}/complete`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify(form),
      });
      const d = await r.json();
      if (d.success) {
        notify("Booking marked as completed ✓");
        onCompleted(d.booking); 
        onClose();
      } else notify(d.error || "Failed", "error");
    } catch { notify("Error completing booking", "error"); }
    setSaving(false);
  };

  if (!booking) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
      <Box sx={{ background: "linear-gradient(135deg, #16a34a, #166534)", px: 3, py: 2.5 }}>
        <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: 17 }}>
          ✅ Mark as Completed
        </Typography>
        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.65)", mt: 0.3 }}>
          {booking.service_name} · {booking.patient_name}
        </Typography>
      </Box>

      <Box sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={1.5}>
            <TextField fullWidth size="small" label="Actual Start Time"
              placeholder="e.g. 10:00 AM"
              value={form.actual_start_time}
              onChange={e => setForm(f => ({ ...f, actual_start_time: e.target.value }))}
              InputProps={{ startAdornment: <InputAdornment position="start"><ScheduleIcon sx={{ fontSize: 16, color: "#16a34a" }} /></InputAdornment> }} />
            <TextField fullWidth size="small" label="Actual End Time"
              placeholder="e.g. 11:30 AM"
              value={form.actual_end_time}
              onChange={e => setForm(f => ({ ...f, actual_end_time: e.target.value }))}
              InputProps={{ startAdornment: <InputAdornment position="start"><ScheduleIcon sx={{ fontSize: 16, color: "#16a34a" }} /></InputAdornment> }} />
          </Stack>

          <TextField fullWidth size="small" label="Time Taken (minutes)" type="number"
            value={form.time_taken_minutes}
            onChange={e => setForm(f => ({ ...f, time_taken_minutes: e.target.value }))}
            InputProps={{ startAdornment: <InputAdornment position="start"><AccessTimeIcon sx={{ fontSize: 16, color: "#16a34a" }} /></InputAdornment> }} />

          <TextField fullWidth size="small" label="Outcome / Completion Notes" multiline rows={3}
            placeholder="Treatment outcome, observations, follow-up required…"
            value={form.completion_notes}
            onChange={e => setForm(f => ({ ...f, completion_notes: e.target.value }))}
            InputProps={{ startAdornment: <InputAdornment position="start"><NotesIcon sx={{ fontSize: 16, color: "#16a34a", mt: 0.5 }} /></InputAdornment> }} />

          <FormControl fullWidth size="small">
            <InputLabel>Treatment Status *</InputLabel>
            <Select value={form.treatment_completed} label="Treatment Status *"
              onChange={e => setForm(f => ({ ...f, treatment_completed: e.target.value }))}>
              <MenuItem value={true}>✅ Completed Successfully</MenuItem>
              <MenuItem value={false}>⚠️ Partially Completed</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Box>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button variant="contained" color="success" onClick={handleComplete} disabled={saving}
          sx={{ fontWeight: 700, px: 3 }}>
          {saving ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Save & Complete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ─── Session Update / Add Dialog ───────────────────────────────────────────
const SessionUpdateDialog = ({ open, booking, session, onClose, onSaved, notify }) => {
  const isAdd = !session;   // no session passed = adding a new one
  const [form, setForm] = useState({
    session_date: "", status: "completed", actual_start_time: "", actual_end_time: "",
    time_taken_minutes: "", notes: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    if (isAdd) {
      setForm({ session_date: "", status: "scheduled", actual_start_time: "", actual_end_time: "", time_taken_minutes: "", notes: "" });
    } else {
      setForm({
        session_date: session.session_date,
        status: session.status === "scheduled" ? "completed" : session.status,
        actual_start_time: session.actual_start_time || "",
        actual_end_time: session.actual_end_time || "",
        time_taken_minutes: session.time_taken_minutes || "",
        notes: session.notes || "",
      });
    }
  }, [open, session, isAdd]);

  const handleSave = async () => {
    if (isAdd && !form.session_date) { notify("Select a date for the new session", "warning"); return; }
    setSaving(true);
    try {
      const url = isAdd
        ? `${API}/nursingphysiotherapy/admin/bookings/${booking._id}/sessions`
        : `${API}/nursingphysiotherapy/admin/bookings/${booking._id}/sessions/${session.session_id}`;
      const method = isAdd ? "POST" : "PATCH";

      const r = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify(form),
      });
      const d = await r.json();
      if (d.success) {
        notify(isAdd ? "Session added ✓" : "Session updated ✓");
        onSaved(d.booking);
        onClose();
      } else notify(d.error || "Failed to save session", "error");
    } catch { notify("Error saving session", "error"); }
    setSaving(false);
  };

  if (!booking) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
      <Box sx={{ background: isAdd ? "linear-gradient(135deg, #7c3aed, #5b21b6)" : "linear-gradient(135deg, #16a34a, #166534)", px: 3, py: 2.5 }}>
        <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: 17 }}>
          {isAdd ? "➕ Add New Session" : "🩺 Update Session"}
        </Typography>
        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.65)", mt: 0.3 }}>
          {isAdd ? booking.patient_name : `${session.session_date} · ${booking.patient_name}`}
        </Typography>
      </Box>
      <Box sx={{ p: 3 }}>
        <Stack spacing={2}>
          {isAdd && (
            <TextField
              fullWidth size="small" label="Session Date *" type="date"
              value={form.session_date}
              onChange={e => setForm(f => ({ ...f, session_date: e.target.value }))}
              InputLabelProps={{ shrink: true }}
            />
          )}
          <FormControl fullWidth size="small">
            <InputLabel>Session Status *</InputLabel>
            <Select value={form.status} label="Session Status *"
              onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
              <MenuItem value="scheduled">🗓️ Scheduled</MenuItem>
              <MenuItem value="completed">✅ Completed</MenuItem>
              <MenuItem value="missed">⚠️ Missed</MenuItem>
              <MenuItem value="cancelled">❌ Cancelled</MenuItem>
            </Select>
          </FormControl>
          {form.status === "completed" && (
            <Stack direction="row" spacing={1.5}>
              <TextField fullWidth size="small" label="Start Time" placeholder="e.g. 10:00 AM"
                value={form.actual_start_time}
                onChange={e => setForm(f => ({ ...f, actual_start_time: e.target.value }))} />
              <TextField fullWidth size="small" label="End Time" placeholder="e.g. 11:00 AM"
                value={form.actual_end_time}
                onChange={e => setForm(f => ({ ...f, actual_end_time: e.target.value }))} />
            </Stack>
          )}
          {form.status === "completed" && (
            <TextField fullWidth size="small" label="Time Taken (minutes)" type="number"
              value={form.time_taken_minutes}
              onChange={e => setForm(f => ({ ...f, time_taken_minutes: e.target.value }))} />
          )}
          <TextField fullWidth size="small" label="Session Notes" multiline rows={2}
            value={form.notes}
            onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} />
        </Stack>
      </Box>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button variant="contained" color={isAdd ? "secondary" : "success"} onClick={handleSave} disabled={saving}
          sx={{ fontWeight: 700, px: 3, ...(isAdd && { bgcolor: "#7c3aed", "&:hover": { bgcolor: "#5b21b6" } }) }}>
          {saving ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : isAdd ? "Add Session" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};


// ─── Set Amount Dialog ────────────────────────────────────────────────────────
const SetAmountDialog = ({ open, booking, onClose, onSaved, notify }) => {
  const [amount, setAmount] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && booking) setAmount(booking.amount_due || "");
  }, [open, booking]);

  const handleSave = async () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      notify("Enter a valid amount", "warning");
      return;
    }
    setSaving(true);
    try {
      const r = await fetch(
        `${API}/nursingphysiotherapy/admin/bookings/${booking._id}/set-amount`,
        {
          method:  "PATCH",
          headers: { "Content-Type": "application/json", ...authHeader() },
          body:    JSON.stringify({ amount }),
        }
      );
      const d = await r.json();
      if (d.success) {
        notify("Amount set — patient notified via SMS ✓");
        onSaved(d.booking);
        onClose();
      } else notify(d.error || "Failed to set amount", "error");
    } catch { notify("Error setting amount", "error"); }
    setSaving(false);
  };

const handleCashPaid = async () => {
  if (!amount || isNaN(amount) || Number(amount) <= 0) {
    notify("Enter a valid amount first", "warning");
    return;
  }
  setSaving(true);
  try {
    const r = await fetch(
      `${API}/nursingphysiotherapy/admin/bookings/${booking._id}/mark-cash-paid`,
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify({ amount }),
      }
    );
    const d = await r.json();
    
    if (d.success) {
      notify("Cash payment recorded ✓", "success");
      onSaved(d.booking);
      onClose();
const community_name=sessionStorage.getItem('user')
    const community=JSON.parse(community_name).address.community_name
    console.log(community)
      try {
        const posOrderData = {
          service_type: "nursing",
          order_id: d.booking.booking_ref,
          items: booking.service_name,
          patient_details: d.booking,
          subtotal: parseInt(amount) || 0,
          discount: 0,
          total_amount: parseInt(amount) || 0,
          payment: { method: "Cash" },
          community_name:community,
          created_at: new Date(`${d.booking.start_date}T${d.booking.scheduled_time}:00`).toISOString(),
          start_date:booking.start_date,
          end_date:booking.end_date,
          scheduled_time:booking.scheduled_time
        };

        const invoice_response = await axios.post(
          `${process.env.REACT_APP_API_INVOICE}/invoice/pos_invoice`,
          posOrderData
        );

        const invoice = invoice_response.data.invoice_details;
        if (invoice.storage_type === "s3") {
          window.open(invoice.cloudfront_url, "_blank");
        } else if (invoice.storage_type === "local") {
          try {
            const token = sessionStorage.getItem("token");
            const response = await axios.get(
              `${process.env.REACT_APP_API_INVOICE}/nursing-invoice/download/${posOrderData.order_id}`,
              {
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
              }
            );
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            window.open(url, "_blank");
          } catch (downloadErr) {
            console.error("Invoice download failed:", downloadErr);
            notify("Payment recorded ✓ — Invoice download failed", "warning");
          }
        }
      } catch (invoiceErr) {
        console.error("Invoice generation failed:", invoiceErr);
        notify("Payment recorded ✓ — Invoice generation failed", "warning");
      }

    } else {
      notify(d.error || "Failed to record cash payment", "error");
    }
  } catch (err) {
 
    console.error("Cash payment error:", err);
    notify("Error recording cash payment", "error");
  } finally {
    setSaving(false);
  }
};

  if (!booking) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
      <Box sx={{ background: "linear-gradient(135deg, #16a34a, #166534)", px: 3, py: 2.5 }}>
        <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: 17 }}>
          💰 Set Payment Amount
        </Typography>
        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.65)", mt: 0.3 }}>
          {booking.service_name} · {booking.patient_name}
        </Typography>
        {booking.payment_status === "paid" && (
          <Box sx={{ mt: 0.75, bgcolor: "rgba(255,255,255,0.2)", px: 1.5, py: 0.4, borderRadius: 1.5, width: "fit-content" }}>
            <Typography sx={{ fontSize: 11, color: "#fff", fontWeight: 700 }}>
              ✅ Already Paid: ₹{booking.amount_paid}
            </Typography>
          </Box>
        )}
      </Box>

      <Box sx={{ p: 3 }}>
        {booking.payment_status === "paid" ? (
          <Alert severity="success" sx={{ borderRadius: 2 }}>
            Patient has already paid ₹{booking.amount_paid} for this booking.
          </Alert>
        ) : (
          <>
            <TextField
              fullWidth size="small" label="Amount (₹)" type="number"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              placeholder="e.g. 500"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CurrencyRupeeIcon sx={{ fontSize: 16, color: "#16a34a" }} />
                  </InputAdornment>
                ),
              }}
            />
            {booking.promo_code && (
                <Alert
                  severity="info"
                  sx={{ mb: 2, borderRadius: 2 ,fontSize:14,mt:1}}
                >
                  🎁 Customer used promo code <strong>{booking.promo_code.code}</strong>
                  {booking.promo_code?.discount_perc > 0 ? (
                    <>
                      and received <strong>{booking.promo_code.discount_perc}%</strong> discount.
                    </>
                  ) : booking.promo_code?.discount > 0 ? (
                    <>
                      and received <strong>₹{booking.promo_code.discount}</strong> discount.
                    </>
                  ) : null}
                  <br />
                  Please collect payment after considering the promotional discount.
                </Alert>
              )}
            <Alert severity="info" sx={{ mt: 2, borderRadius: 2, fontSize: 12 }}>
              Patient will receive an SMS with payment link after you set this amount.
            </Alert>
          </>
        )}
      </Box>

  
<DialogActions sx={{ px: 3, pb: 2.5, gap: 1, flexWrap: "wrap" }}>
  <Button onClick={onClose} color="inherit">Close</Button>
  {booking.payment_status !== "paid" && (
    <>
      {/* Online payment — set amount and notify patient */}
      <Button variant="outlined" color="success" onClick={handleSave} disabled={saving}
        sx={{ fontWeight: 700, px: 2, borderRadius: 2 }}>
        {saving ? <CircularProgress size={18} /> : "Set & Notify"}
      </Button>

      {/* COD — mark as cash paid immediately */}
      <Button variant="contained" onClick={handleCashPaid} disabled={saving || !amount || isNaN(amount) || Number(amount) <= 0}
        sx={{ fontWeight: 700, px: 2, borderRadius: 2, bgcolor: "#d97706",
          "&:hover": { bgcolor: "#b45309" } }}>
        {saving ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Mark Cash Paid"}
      </Button>
    </>
  )}
</DialogActions>
    </Dialog>
  );
};
// ─── Mark Cash Paid Dialog (for unpaid bookings) ──────────────────────────────
const MarkCashPaidDialog = ({ open, booking, onClose, onSaved, notify }) => {
  const [amount, setAmount] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && booking) setAmount(booking.amount_due || "");
  }, [open, booking]);

  const handleMarkPaid = async () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      notify("Enter a valid amount", "warning");
      return;
    }
    setSaving(true);
    try {
      const r = await fetch(
        `${API}/nursingphysiotherapy/admin/bookings/${booking._id}/mark-cash-paid`,
        {
          method:  "PATCH",
          headers: { "Content-Type": "application/json", ...authHeader() },
          body:    JSON.stringify({ amount }),
        }
      );
      const d = await r.json();
      if (d.success) {
        notify("Cash payment recorded ✓");
        onSaved(d.booking);  
        onClose();
        const community_name=sessionStorage.getItem('user')
            const community=JSON.parse(community_name).address.community_name
            console.log(community)
        const posOrderData={ 
        service_type:"nursing",
          order_id: d.booking.booking_ref,
          items: booking.service_name,
          patient_details: d.booking,
          subtotal: parseInt(amount) ||0 ,
          discount: 0,
          total_amount: parseInt(amount)  ||0,
          payment: { method: "Cash" },
          community_name:community,
          created_at: new Date(`${d.booking.start_date}T${d.booking.scheduled_time}:00`).toISOString(),
          start_date:booking.start_date,
          end_date:booking.end_date,
          scheduled_time:booking.scheduled_time
        }
          try {
            const invoice_response = await axios.post(
              `${process.env.REACT_APP_API_INVOICE}/invoice/pos_invoice`,
              posOrderData,
            );
      
          const invoice = invoice_response.data.invoice_details;
          if (invoice.storage_type === "s3") {
            // Open CloudFront URL
            window.open(invoice.cloudfront_url, "_blank");
          } else if (invoice.storage_type === "local") {
            try {
            const token = sessionStorage.getItem("token");

            const response = await axios.get(
              `${process.env.REACT_APP_API_INVOICE}/nursing-invoice/download/${posOrderData.order_id}`,
              {
                responseType: "blob",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            window.open(url, "_blank");

          } catch (error) {
            console.error("Invoice download failed:", error);
          }
          }
          } catch (error) {
            console.error("Invoice generation failed:", error);
          }
      } else notify(d.error || "Failed", "error");
    } catch { notify("Error recording cash payment", "error"); }
    setSaving(false);
  };

  if (!booking) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
      <Box sx={{ background: "linear-gradient(135deg, #d97706, #b45309)", px: 3, py: 2.5 }}>
        <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: 17 }}>
          💵 Mark as Cash Paid
        </Typography>
        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.65)", mt: 0.3 }}>
          {booking.service_name} · {booking.patient_name}
        </Typography>
        <Box sx={{ mt: 0.75, bgcolor: "rgba(255,255,255,0.15)", px: 1.5, py: 0.4,
          borderRadius: 1.5, width: "fit-content" }}>
          <Typography sx={{ fontSize: 11, color: "#fff", fontWeight: 700 }}>
            Ref: {booking.booking_ref}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ p: 3 }}>
        <TextField
          fullWidth size="small" label="Amount Collected (₹)" type="number"
          value={amount}
          onChange={e => setAmount(e.target.value)}
          placeholder="e.g. 500"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CurrencyRupeeIcon sx={{ fontSize: 16, color: "#d97706" }} />
              </InputAdornment>
            ),
          }}
        />
        {booking.promo_code && (
              <Box
                sx={{
                  mt: 1,
                  bgcolor: "rgba(255,255,255,0.15)",
                  px: 1.5,
                  py: 0.4,
                  borderRadius: 1.5,
                  width: "fit-content",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 15,
                    color: "#791919",
                    fontWeight: 700,
                  }}
                >
                  🎁 Promo Used: {booking.promo_code.code}
                  {booking.promo_code.discount_perc > 0 ? ` (₹${booking.promo_code.discount_perc}% Off)`: booking.promo_code.discount ? ` (₹${booking.promo_code.discount} Off)` : ""}
                  <br />
                  Please collect payment after considering the promotional discount.
                </Typography>
              </Box>
            )}
        <Alert severity="warning" sx={{ mt: 2, borderRadius: 2, fontSize: 12 }}>
          This will immediately mark the booking as <strong>Cash Paid</strong> and notify admin. Use only when patient pays in cash.
        </Alert>
      </Box>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button variant="contained" onClick={handleMarkPaid} disabled={saving}
          sx={{ fontWeight: 700, px: 3, borderRadius: 2,
            bgcolor: "#d97706", "&:hover": { bgcolor: "#b45309" } }}>
          {saving ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "💵 Confirm Cash Paid"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};





// ─── Upload Agreement Dialog ──────────────────────────────────────────────────
const UploadAgreementDialog = ({ open, booking, onClose, onSaved, notify }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) { setFile(null); setError(""); } }, [open]);

  const handleSelect = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!["application/pdf", "image/jpeg", "image/png"].includes(f.type)) {
      setError("Only PDF, JPG or PNG files are allowed"); return;
    }
    if (f.size > 10 * 1024 * 1024) { setError("File must be under 10MB"); return; }
    setError(""); setFile(f);
  };

  const handleUpload = async () => {
    if (!file) { notify("Select a file first", "warning"); return; }
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("agreement", file);
      const r = await fetch(`${API}/nursingphysiotherapy/admin/bookings/${booking._id}/upload-agreement`, {
        method: "POST",
        headers: { ...authHeader() },
        body: fd,
      });
      const d = await r.json();
      if (d.success) {
        notify("Agreement uploaded ✓");
        onSaved(d.booking);
        onClose();
      } else notify(d.error || "Upload failed", "error");
    } catch { notify("Error uploading agreement", "error"); }
    setSaving(false);
  };

  if (!booking) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
      <Box sx={{ background: "linear-gradient(135deg, #006D77, #004E56)", px: 3, py: 2.5 }}>
        <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: 17 }}>
          📄 Upload Signed Agreement
        </Typography>
        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.65)", mt: 0.3 }}>
          {booking.service_name} · {booking.patient_name}
        </Typography>
      </Box>

      <Box sx={{ p: 3 }}>
        {booking.agreement && (
          <Alert severity="info" sx={{ mb: 2, borderRadius: 2, fontSize: 12 }}>
            An agreement is already on file. Uploading a new one will replace it.
          </Alert>
        )}
        <Box component="label" sx={{
          border: "2px dashed", borderColor: alpha("#006D77", 0.35),
          borderRadius: 2, py: 4, px: 2, textAlign: "center", cursor: "pointer", display: "block",
          "&:hover": { bgcolor: alpha("#006D77", 0.04) },
        }}>
          <input type="file" hidden accept=".pdf,.jpg,.jpeg,.png" onChange={handleSelect} />
          <AssignmentTurnedInIcon sx={{ fontSize: 30, color: "#006D77", mb: 1 }} />
          <Typography fontWeight={700} fontSize={13}>
            {file ? file.name : "Click to select scanned agreement"}
          </Typography>
          <Typography fontSize={11} color="text.secondary" mt={0.5}>PDF, JPG or PNG — up to 10MB</Typography>
        </Box>
        {error && <Alert severity="error" sx={{ mt: 2, borderRadius: 2, fontSize: 12 }}>{error}</Alert>}
      </Box>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button variant="contained" disabled={!file || saving} onClick={handleUpload}
          sx={{ bgcolor: "#006D77", fontWeight: 700, px: 3, "&:hover": { bgcolor: "#004E56" } }}>
          {saving ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Upload"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};


// ─── Document Viewer Dialog (inline preview) ──────────────────────────────────
const DocumentViewerDialog = ({ url, onClose }) => {
  if (!url) return null;
  const isPdf = url.toLowerCase().endsWith(".pdf");

  return (
    <Dialog open={!!url} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography fontWeight={700}>Document Preview</Typography>
        <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, bgcolor: "#000", minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {isPdf ? (
          <iframe src={url} title="document" width="100%" height="700px" style={{ border: "none" }} />
        ) : (
          <Box component="img" src={url} alt="document" sx={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }} />
        )}
      </DialogContent>
    </Dialog>
  );
};





// ─── Staff Management Dialog ──────────────────────────────────────────────────
const StaffManagementDialog = ({ open, onClose, notify }) => {
  const [staffList,  setStaffList]  = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [saving,     setSaving]     = useState(false);
  const [showForm,   setShowForm]   = useState(false);
  const [editStaff,  setEditStaff]  = useState(null);
  const [form,       setForm]       = useState({ name: "", phone: "", email: "", category: "nursing" });

  const fetchStaff = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}/nursingphysiotherapy/admin/staff`, { headers: authHeader() });
      const d = await r.json();
      if (d.success) setStaffList(d.staff || []);
    } catch { notify("Failed to load staff", "error"); }
    setLoading(false);
  }, []);

  useEffect(() => { if (open) fetchStaff(); }, [open]);

  const openAdd  = ()      => { setForm({ name: "", phone: "", email: "", category: "nursing" }); setEditStaff(null); setShowForm(true); };
  const openEdit = (staff) => { setForm({ name: staff.name, phone: staff.phone, email: staff.email || "", category: staff.category }); setEditStaff(staff); setShowForm(true); };

  const handleSave = async () => {
    if (!form.name.trim() || !form.phone.trim()) { notify("Name and phone are required", "warning"); return; }
    setSaving(true);
    try {
      const url    = editStaff ? `${API}/nursingphysiotherapy/admin/staff/${editStaff._id}` : `${API}/nursingphysiotherapy/admin/staff`;
      const method = editStaff ? "PUT" : "POST";
      const r = await fetch(url, { method, headers: { "Content-Type": "application/json", ...authHeader() }, body: JSON.stringify(form) });
      const d = await r.json();
      if (d.success) { notify(editStaff ? "Staff updated ✓" : "Staff added ✓"); setShowForm(false); fetchStaff(); }
      else notify(d.error || "Save failed", "error");
    } catch { notify("Error saving staff", "error"); }
    setSaving(false);
  };

  const handleDelete = async (staffId) => {
    try {
      const r = await fetch(`${API}/nursingphysiotherapy/admin/staff/${staffId}`, { method: "DELETE", headers: authHeader() });
      const d = await r.json();
      if (d.success) { notify("Staff removed ✓", "warning"); fetchStaff(); }
    } catch { notify("Error removing staff", "error"); }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
      <Box sx={{ background: "linear-gradient(135deg, #003D45 0%, #006D77 100%)", px: 3, py: 2.5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box>
          <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: 17 }}>
            👥 Staff Management
          </Typography>
          <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.6)", mt: 0.3 }}>
            Manage nurses and physiotherapists
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button size="small" variant="outlined" startIcon={<PersonAddIcon />}
            onClick={openAdd}
            sx={{ color: "#fff", borderColor: "rgba(255,255,255,0.4)", "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,0.1)" }, fontWeight: 700 }}>
            Add Staff
          </Button>
          <IconButton size="small" onClick={onClose} sx={{ color: "#fff", bgcolor: "rgba(255,255,255,0.12)" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      <DialogContent sx={{ p: 0 }}>
        {/* Add/Edit form */}
        {showForm && (
          <Box sx={{ p: 2.5, bgcolor: "#F0FDF4", borderBottom: "1px solid #E2E8F0" }}>
            <Typography fontWeight={800} fontSize={14} color="#16a34a" mb={1.5}>
              {editStaff ? "✏️ Edit Staff" : "➕ Add New Staff"}
            </Typography>
            <Stack spacing={1.5}>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                <TextField fullWidth size="small" label="Full Name *" value={form.name}
                  onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
                <TextField fullWidth size="small" label="Phone *" value={form.phone}
                  onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
              </Stack>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                <TextField fullWidth size="small" label="Email" value={form.email}
                  onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
                <FormControl fullWidth size="small">
                  <InputLabel>Category *</InputLabel>
                  <Select value={form.category} label="Category *"
                    onChange={e => setForm(f => ({ ...f, category: e.target.value }))}>
                    <MenuItem value="nursing">🏥 Nursing</MenuItem>
                    <MenuItem value="physiotherapy">💪 Physiotherapy</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Button size="small" onClick={() => setShowForm(false)} color="inherit">Cancel</Button>
                <Button size="small" variant="contained" onClick={handleSave} disabled={saving} color="success"
                  sx={{ fontWeight: 700 }}>
                  {saving ? "Saving…" : editStaff ? "Update" : "Add Staff"}
                </Button>
              </Stack>
            </Stack>
          </Box>
        )}

        {/* Staff list */}
        {loading ? (
          <Box sx={{ textAlign: "center", py: 5 }}>
            <CircularProgress size={28} sx={{ color: "#006D77" }} />
          </Box>
        ) : staffList.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 6, px: 3 }}>
            <PersonIcon sx={{ fontSize: 48, color: "#CBD5E1", mb: 1 }} />
            <Typography fontWeight={700} color="text.secondary">No staff added yet</Typography>
            <Typography fontSize={13} color="text.secondary" mt={0.5}>Click "Add Staff" to add your first nurse or physiotherapist</Typography>
          </Box>
        ) : (
          <Box>
            {staffList.map((staff, idx) => {
              const meta = CAT_META[staff.category] || CAT_META.nursing;
              return (
                <Box key={staff._id} sx={{
                  display: "flex", alignItems: "center", gap: 2,
                  px: 2.5, py: 1.75,
                  borderBottom: idx < staffList.length - 1 ? "1px solid #f1f5f9" : "none",
                  "&:hover": { bgcolor: "#f8fafc" },
                }}>
                  <Box sx={{ width: 38, height: 38, borderRadius: "50%", background: meta.gradient, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: 15, flexShrink: 0 }}>
                    {staff.name.charAt(0).toUpperCase()}
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography fontWeight={700} fontSize={13}>{staff.name}</Typography>
                    <Typography fontSize={11} color="text.secondary">{staff.phone}{staff.email ? ` · ${staff.email}` : ""}</Typography>
                  </Box>
                  <Chip label={meta.label} size="small"
                    sx={{ bgcolor: meta.lightBg, color: meta.accent, fontWeight: 700, fontSize: 10, flexShrink: 0 }} />
                  <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
                    <Tooltip title="Edit">
                      <IconButton size="small" onClick={() => openEdit(staff)}
                        sx={{ color: "#006D77", bgcolor: alpha("#006D77", 0.08), width: 28, height: 28 }}>
                        <AssignmentTurnedInIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Remove">
                      <IconButton size="small" onClick={() => handleDelete(staff._id)}
                        sx={{ color: "#DC2626", bgcolor: alpha("#DC2626", 0.08), width: 28, height: 28 }}>
                        <CancelIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}
      </DialogContent>

      <Divider />
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit" variant="outlined" sx={{ borderRadius: 2 }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

// ─── MAIN EXPORT ─────────────────────────────────────────────────────────────
export default function NursingPhysioAdmin() {
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(muiTheme.breakpoints.down("md"));

  const [bookings,       setBookings]       = useState([]);
  const [catFilter,      setCatFilter]      = useState("all");
  const [statusFilter,   setStatusFilter]   = useState("all");
  const [search,         setSearch]         = useState("");
  const [viewBkg,        setViewBkg]        = useState(null);
  const [assignDlg,      setAssignDlg]      = useState({ open: false, booking: null });
  const [completeDlg,    setCompleteDlg]    = useState({ open: false, booking: null });
  const [staffMgmtOpen,  setStaffMgmtOpen]  = useState(false);
  const [amountDlg,      setAmountDlg]      = useState({ open: false, booking: null });
  const [cashPaidDlg,    setCashPaidDlg]    = useState({ open: false, booking: null });
  const [agreementDlg,   setAgreementDlg]   = useState({ open: false, booking: null });
  const [viewDocUrl,     setViewDocUrl]     = useState(null); 
  const [sessionDlg,     setSessionDlg]     = useState({ open: false, booking: null, session: null });
  const [snack,          setSnack]          = useState({ open: false, msg: "", sev: "success" });
  const [page,           setPage]           = useState(1);
  const [viewMode,     setViewMode]     = useState("card")
  const notify    = (msg, sev = "success") => setSnack({ open: true, msg, sev });
  const PAGE_SIZE = 8;
  const bookingsFetchedRef = useRef(false);
  const [limit, setLimit] = useState(8);
  const [totalPages, setTotalPages] = useState(1);
  const [total,setTotal]=useState(0);
  const [stats,setStats]=useState({})
  const [searchInput, setSearchInput] = useState('');
  const [selectedCommunity, setSelectedCommunity]=useState("all")
  const [communities, setCommunities] = useState([]);


  // ── Fetch ──────────────────────────────────────────────────────────────────
  const fetchBookings = useCallback(async () => {
    try {
      const params = new URLSearchParams({
      page,
      limit,
    });

    if (catFilter !== "all") {
      params.append("category", catFilter);
    }

    if (statusFilter !== "all") {
      params.append("status", statusFilter);
    }
     if (selectedCommunity !== "all") {
      params.append("community", selectedCommunity);
    }

    if (search.trim()) {
      params.append("search", search.trim());
    }
    console.log(params.toString())
      const r = await fetch(`${API}/nursingphysiotherapy/admin/bookings?${params.toString()}`, { headers: authHeader() });
      const d = await r.json();
      if (d.success) {
      setBookings(d.bookings || []);
      registerFetchedOrders('nursing', (d.bookings || []).map(b => ({ id: b._id, status: b.status })));
      setTotalPages(d.total_pages || 1);
      setTotal(d.total)
      setStats(d.stats)
      }
      else notify(d.error || "Failed to load bookings", "error");
    } catch { notify("Cannot reach server", "error"); }
  }, [page, limit, catFilter,selectedCommunity, statusFilter, search]);

useEffect(() => {
   const local_communities=sessionStorage.getItem('communities')
  console.log(local_communities)
  setCommunities(JSON.parse(local_communities))
  fetchBookings();
}, [fetchBookings]);

useEffect(() => {
  setPage(1);
}, [catFilter, statusFilter,selectedCommunity, search]);
  // ── Status update ──────────────────────────────────────────────────────────
  const handleStatus = async (id, status) => {
    try {
      const r = await fetch(`${API}/nursingphysiotherapy/admin/bookings/${id}/status`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify({ status }),
      });
      const d = await r.json();
      if (d.success) { notify(`Booking ${STATUS_CFG[status]?.label}`); fetchBookings(); }
    } catch { notify("Update failed", "error"); }
  };
const handleViewBooking = (b) => {
  markOrderSeen('nursing', b._id); 
  setViewBkg(b);
};
const updateBookingInState = (updatedBooking) => {
  setBookings(prev => prev.map(b => b._id === updatedBooking._id ? updatedBooking : b));
  // If this booking is currently open in view dialog, refresh it too
  setViewBkg(prev => prev && prev._id === updatedBooking._id ? updatedBooking : prev);
};
  // ── Derived ────────────────────────────────────────────────────────────────
  const paged = bookings;



  const TH = { fontWeight: 700, fontSize: { xs: 11, sm: 12 }, color: "#64748B", textTransform: "uppercase", letterSpacing: 0.4, whiteSpace: "nowrap" };
  const TD = { fontSize: { xs: 12, sm: 13 }, py: 1.25 };

  return (
    <ThemeProvider theme={adminTheme}>
      <link href="https://fonts.googleapis.com/css2?family=Sora:wght@700;800;900&family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />

      <Box sx={{
        minHeight: "100vh",
        pt: { xs: `${MOBILE_BAR_H}px`, md: 0 },
        boxSizing: "border-box", overflowX: "hidden",
      }}>
        {/* ── Sticky header ── */}
        <Box sx={{
          bgcolor: "white", borderBottom: "1px solid #e2e8f0",
          px: { xs: 2, sm: 3, md: 4 }, py: { xs: 1.5, sm: 2 },
          position: "sticky", top: { xs: `${MOBILE_BAR_H}px`, md: 0 },
          zIndex: 99, boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
        }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
            <Box>
              <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: { xs: 15, sm: 19, md: 21 }, color: "#006D77" }}>
                📋 Nursing & Physiotherapy — Bookings
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {stats.pending} pending · {stats.confirmed} confirmed · {stats.completed} completed · {stats.total} total
              </Typography>
            </Box>
            <Stack direction="row" spacing={1} alignItems="center">
              {/* Staff management button */}
              <Button size="small" variant="outlined" startIcon={<PersonAddIcon />}
                onClick={() => setStaffMgmtOpen(true)}
                sx={{ borderColor: "#7c3aed", color: "#7c3aed", fontWeight: 700, borderRadius: 2,
                  "&:hover": { bgcolor: alpha("#7c3aed", 0.06) }, display: { xs: "none", sm: "flex" } }}>
                Manage Staff
              </Button>
              <Tooltip title="Manage Staff">
                <IconButton size="small" onClick={() => setStaffMgmtOpen(true)}
                  sx={{ color: "#7c3aed", display: { xs: "flex", sm: "none" } }}>
                  <PersonAddIcon fontSize="small" />
                </IconButton>
              </Tooltip>
                     {/* VIEW TOGGLE */}
                        <ToggleButtonGroup
                          value={viewMode}
                          exclusive
                          onChange={(e, val) => val && setViewMode(val)}
                          sx={{ mb: 1, mt:1, mr:5 }}
                        >
                          <ToggleButton value="card">
                            <ViewModuleIcon />
                            Card
                          </ToggleButton>
                          <ToggleButton value="table">
                            <ViewListIcon />
                            Table
                          </ToggleButton>
                        </ToggleButtonGroup>
              <Tooltip title="Refresh">
                <IconButton size="small" onClick={fetchBookings} sx={{ color: "#006D77" }}>
                  <RefreshIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>
          </Box>
        </Box>

        <Container maxWidth="xl" sx={{ px: { xs: 1.5, sm: 2.5, md: 4 }, py: { xs: 2, sm: 3 }, pb: 6 }}>

          {/* ── Stat cards ── */}
          <Grid container spacing={{ xs: 1, md: 1.5 }} mb={2.5}>
            {[
              { label: "Total Bookings", value: stats.total,     gradient: "linear-gradient(135deg,#7c3aed,#5b21b6)", icon: <BookOnlineIcon /> },
              { label: "Pending",        value: stats.pending,   gradient: "linear-gradient(135deg,#d97706,#b45309)", icon: <CalendarMonthIcon /> },
              { label: "Confirmed",      value: stats.confirmed, gradient: "linear-gradient(135deg,#0284c7,#075985)", icon: <DashboardIcon /> },
              { label: "Completed",      value: stats.completed, gradient: "linear-gradient(135deg,#16a34a,#166534)", icon: <TaskAltIcon /> },
              { label: "Cancelled",      value: stats.cancelled, gradient: "linear-gradient(135deg,#dc2626,#991b1b)", icon: <CancelIcon /> },
              { label: "Nursing",        value: stats.nursing,   gradient: "linear-gradient(135deg,#006D77,#004E56)", icon: <MedicalServicesIcon /> },
              { label: "Physiotherapy",  value: stats.physio,    gradient: "linear-gradient(135deg,#b8654a,#8B3E2F)", icon: <MedicalServicesIcon /> },
            ].map((s, i) => (
              <Grid item xs={6} sm={4} md={3} key={i}><StatCard {...s} /></Grid>
            ))}
          </Grid>

          {/* ── Filter bar ── */}
          <Card sx={{ mb: 2 }}>
            <CardContent sx={{ py: 1.5, px: 2, "&:last-child": { pb: 1.5 } }}>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ sm: "center" }} flexWrap="wrap">
                <TextField placeholder="Search patient, ref, service…"  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setSearch(searchInput);
                      setPage(1);
                    }}}
                  InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon sx={{ fontSize: 16, color: "text.secondary" }} /></InputAdornment> }}
                  sx={{ flex: 1, minWidth: { xs: "100%", sm: 180 } }} />
                   <Button
              variant="contained"
              size="small"
              onClick={() => {
                setSearch(searchInput);
                setPage(1);
              }}
              sx={{
                bgcolor: '#006D77',
                '&:hover': {
                  bgcolor: '#005560',
                },
                minWidth: 70,
              }}
            >
              Search
            </Button>
             <FormControl sx={{ minWidth: { xs: "100%", sm: 140 } }}>
                  <InputLabel>Community</InputLabel>
                  <Select value={selectedCommunity} label="Status" onChange={e => setSelectedCommunity(e.target.value)}>
                    <MenuItem value="all">All Communities</MenuItem>
                    {communities.map((community) => (
                      <MenuItem key={community.name} value={community.name}>{community.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
            
                <FormControl sx={{ minWidth: { xs: "100%", sm: 140 } }}>
                  <InputLabel>Status</InputLabel>
                  <Select value={statusFilter} label="Status" onChange={e => setStatusFilter(e.target.value)}>
                    <MenuItem value="all">All Statuses</MenuItem>
                    {Object.entries(STATUS_CFG).map(([k, v]) => (
                      <MenuItem key={k} value={k}>{v.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ minWidth: { xs: "100%", sm: 150 } }}>
                  <InputLabel>Category</InputLabel>
                  <Select value={catFilter} label="Category" onChange={e => setCatFilter(e.target.value)}>
                    <MenuItem value="all">All Categories</MenuItem>
                    <MenuItem value="nursing">🏥 Nursing</MenuItem>
                    <MenuItem value="physiotherapy">💪 Physiotherapy</MenuItem>
                  </Select>
                </FormControl>
                  {/* Clear Filters */}
                  {(catFilter !== "all" || selectedCommunity!=="all" ||  statusFilter!=="all" ||!(search=="")) && (
                  <Button
                    size="small"
                    onClick={() => {setCatFilter("all");setStatusFilter("all");setSearchInput('');setSearch('');setSelectedCommunity("all")}}
                    startIcon={<ClearIcon />} // ✅ clear icon added
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      color: "#006D77",
                    }}
                  >
                    Clear Filter
                  </Button>
                )}
              </Stack>
            </CardContent>
          </Card>

          {/* ── Results ── */}
          {isMobile ? (
            <Box>
              {paged.map(b => (
          

                <BookingMobileCard key={b._id} b={b}
                  onStatus={handleStatus}
                  // onView={setViewBkg}
                  onView={handleViewBooking}
                  onAssign={b => setAssignDlg({ open: true, booking: b })}
                  onComplete={b => setCompleteDlg({ open: true, booking: b })}
                  onSetAmount={b => setAmountDlg({ open: true, booking: b })}
                  onCashPaid={b => setCashPaidDlg({ open: true, booking: b })}
                  onUploadAgreement={b => setAgreementDlg({ open: true, booking: b })}
                />
              ))}
              {paged.length === 0 && (
                <Box sx={{ textAlign: "center", py: 6, color: "text.secondary" }}>
                  <BookOnlineIcon sx={{ fontSize: 40, opacity: 0.2 }} />
                  <Typography>No bookings found</Typography>
                </Box>
              )}
              <PaginationBar page={page} totalPages={totalPages} onPageChange={setPage}
                total={total} pageSize={PAGE_SIZE} label="bookings" />
            </Box>
          ) : (
            <Paper variant="outlined" sx={{ borderRadius: 1, overflow: "hidden" }}>
              <Box sx={{ background: "linear-gradient(135deg, #003D45 0%, #006D77 100%)", px: 3, py: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box>
                  <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: 16 }}>
                    All Bookings
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.6)" }}>
                    {stats.pending} pending · {stats.confirmed} confirmed · {stats.completed} completed
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Chip label={`${stats.pending} Pending`}
                    sx={{ bgcolor: "rgba(253,230,138,0.2)", color: "#FDE68A", fontWeight: 700, fontSize: 11, border: "1px solid rgba(253,230,138,0.3)" }} />
                  <Chip label={`${stats.confirmed} Confirmed`}
                    sx={{ bgcolor: "rgba(147,197,253,0.2)", color: "#93C5FD", fontWeight: 700, fontSize: 11, border: "1px solid rgba(147,197,253,0.3)", display: { xs: "none", sm: "flex" } }} />
                </Box>
              </Box>
             {viewMode=="table" ?( <TableContainer sx={{ overflowX: "auto" }}>
                <Table sx={{ minWidth: isTablet ? 680 : 1100 }}>
                  <TableHead>
                    <TableRow>
                        {["Ref", "Patient", "Phone", "Service", "Cat.", "Date & Time", "Assigned Staff", "Status", "Payment", "Actions"].map(h => (
                        <TableCell key={h} sx={{ ...TH }}>{h}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paged.map(b => (
                      <TableRow key={b._id}>
   
                        <TableCell sx={{ ...TD }}>
                          <Typography variant="caption" sx={{ fontFamily: "monospace", color: "#006D77", fontWeight: 700 }}>
                            {b.booking_ref}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ ...TD }}><Typography fontWeight={700} fontSize={13}>{b.patient_name}</Typography></TableCell>
                        <TableCell sx={{ ...TD }}><Typography fontSize={12}>{b.patient_phone}</Typography></TableCell>
                        <TableCell sx={{ ...TD, maxWidth: 140 }}>
                          <Typography fontSize={12} sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {b.service_name}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ ...TD }}><CatChip value={b.category} /></TableCell>
                        <TableCell sx={{ ...TD }}>
                          <Typography fontSize={12} fontWeight={600}> {b.start_date && b.end_date
    ? `${b.start_date} → ${b.end_date}`
    : b.scheduled_date}</Typography>
                          <Typography fontSize={11} color="text.secondary">{b.scheduled_time}</Typography>
                        </TableCell>
                        {/* Assigned staff column */}
                        <TableCell sx={{ ...TD }}>
                          {b.assigned_staff_name ? (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              <Box sx={{ width: 22, height: 22, borderRadius: "50%", background: "linear-gradient(135deg,#7c3aed,#5b21b6)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 10, fontWeight: 800, flexShrink: 0 }}>
                                {b.assigned_staff_name.charAt(0)}
                              </Box>
                              <Box>
                                <Typography fontSize={12} fontWeight={700}>{b.assigned_staff_name}</Typography>
                                <Typography fontSize={10} color="text.secondary">{b.assigned_staff_phone}</Typography>
                              </Box>
                            </Box>
                          ) : (
                            <Typography fontSize={12} color="text.secondary">—</Typography>
                          )}
                        </TableCell>
                        <TableCell sx={{ ...TD }}><StatusChip value={b.status} /></TableCell>
                        <TableCell sx={{ ...TD }}>
                        {b.status === "completed" ? (
                          <Stack spacing={0.5}>
                            <PaymentChip value={b.payment_status} paymentId={b.payment_id} />
                            {b.amount_due && (
                              <Typography fontSize={11} color="text.secondary">₹{b.amount_due}</Typography>
                            )}
                          </Stack>
                        ) : (
                          <Typography fontSize={12} color="text.secondary">—</Typography>
                        )}
                      </TableCell>
                        <TableCell sx={{ ...TD }}>
                          <Stack direction="row" spacing={0.3}>
                            {/* View */}
                            <Tooltip title="View Details">
                              {/* <IconButton size="small" onClick={() => setViewBkg(b)} */}
                              <IconButton onClick={() => handleViewBooking(b)}
                                sx={{ color: "#006D77", bgcolor: alpha("#006D77", 0.08), "&:hover": { bgcolor: alpha("#006D77", 0.16) } }}>
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={b.agreement ? "Replace Agreement" : "Upload Agreement"}>
                              <IconButton size="small" onClick={() => setAgreementDlg({ open: true, booking: b })}
                                sx={{ color: "#006D77", bgcolor: alpha("#006D77", 0.08), "&:hover": { bgcolor: alpha("#006D77", 0.16) } }}>
                                <AssignmentTurnedInIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            {b.status === "completed" && b.payment_status !== "paid" && (
                              <>
                                <Tooltip title="Set Payment Amount">
                                  <IconButton size="small"
                                    onClick={() => setAmountDlg({ open: true, booking: b })}
                                    sx={{ color: "#16a34a", bgcolor: alpha("#16a34a", 0.08), "&:hover": { bgcolor: alpha("#16a34a", 0.16) } }}>
                                    <CurrencyRupeeIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Mark Cash Paid">
                                  <IconButton size="small"
                                    onClick={() => setCashPaidDlg({ open: true, booking: b })}
                                    sx={{ color: "#d97706", bgcolor: alpha("#d97706", 0.08), "&:hover": { bgcolor: alpha("#d97706", 0.16) } }}>
                                    <PaymentIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}
                            {b.status === "completed" && b.payment_status === "paid" && (
                              <Tooltip title={`Paid ₹${b.amount_paid}`}>
                                <IconButton size="small" disabled
                                  sx={{ color: "#059669", bgcolor: alpha("#059669", 0.08) }}>
                                  <PaymentIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                            {/* Assign staff */}
                            {(b.status === "pending" || b.status === "confirmed") && (
                              <Tooltip title={b.assigned_staff_name ? "Reassign Staff" : "Assign Staff"}>
                                <IconButton size="small"
                                  onClick={() => setAssignDlg({ open: true, booking: b })}
                                  sx={{ color: "#7c3aed", bgcolor: alpha("#7c3aed", 0.08), "&:hover": { bgcolor: alpha("#7c3aed", 0.16) } }}>
                                  <PersonAddIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                            {/* Confirm */}
                            {b.status === "pending" && (
                              <Tooltip title="Confirm">
                                <IconButton size="small" color="success" onClick={() => handleStatus(b._id, "confirmed")}>
                                  <CheckCircleIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                            {/* Complete */}
                            {b.status === "confirmed" && (
                              <Tooltip title="Mark Completed">
                                <IconButton size="small" color="success"
                                  onClick={() => setCompleteDlg({ open: true, booking: b })}>
                                  <TaskAltIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          
                            {/* Cancel */}
                            {(b.status === "pending" || b.status === "confirmed") && (
                              <Tooltip title="Cancel">
                                <IconButton size="small" color="error" onClick={() => handleStatus(b._id, "cancelled")}>
                                  <CancelIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                    {paged.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={9} align="center" sx={{ py: 5, color: "text.secondary" }}>No bookings found</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>):(

              <Grid container spacing={2} sx={{backgroundColor:"#f6f7fa"}}>
                  {paged.map((b) => {
                    const meta = CAT_META[b.package_id];
                    const isNew = isOrderUnseen('nursing', b._id);

                    return (
                      <Grid item xs={12} sm={6} md={4} key={b._id} ml={1}  mt={2} mb={1} >
                    <Card
                      sx={{
                        borderRadius: 1,
                        width: 300,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        border: isNew ? "2px solid #f8e7e7" : "1px solid #E5E7EB", // ← CHANGED
                        bgcolor: isNew ? "#FEF2F2" : "#fff", // ← CHANGED
                        boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
                        transition: "all 0.25s ease",
                        overflow: "hidden",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 12px 24px rgba(0,0,0,0.10)",
                          borderColor: isNew ? "#f1b4b4" : "#006d77" // ← CHANGED
                        },
                      }}
                    >
                        <CardContent sx={{ flex: 1 }}>
                          
                          {/* Header */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              mb: 1,
                            }}
                          >
                            <Box>
                              <Typography
                                variant="h6"
                                color="#006D77"
                                fontWeight="bold"
                                sx={{ fontSize: 15 }}
                              >
                                {b.booking_ref}
                              </Typography>

                              <Typography variant="caption" color="text.secondary">
                                  {b.start_date && b.end_date
                          ? `${b.start_date} → ${b.end_date}`
                          : b.scheduled_date}
                        {" · "}
                        {b.scheduled_time}
                              </Typography>
                            </Box>

                            <Stack spacing={0.5} alignItems="flex-end">
                              <StatusChip value={b.status} />
                            </Stack>
                          </Box>

                          <Divider sx={{ my: 0.5}}  />

                          {/* Booking Info */}
                          <List dense disablePadding>
                            <ListItem disablePadding sx={{ mb: 1 }}>
                              <ListItemIcon sx={{ minWidth: 32 }}>
                                <PersonIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText
                                primary={b.patient_name}
                                primaryTypographyProps={{
                                  variant: "body2",
                                  fontWeight: 600,
                                  noWrap: true,
                                }}
                              />
                            </ListItem>

                            <ListItem disablePadding sx={{ mb: 1 }}>
                              <ListItemIcon sx={{ minWidth: 32 }}>
                                <PhoneIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText
                                primary={b.patient_phone}
                                primaryTypographyProps={{ variant: "body2" }}
                              />
                            </ListItem>

                            <ListItem disablePadding sx={{ mb: 1 }}>
                              <ListItemIcon sx={{ minWidth: 32 }}>
                                <MedicalServicesIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText
                                primary={b.service_name?.replace("Ayuja ", "")}
                                primaryTypographyProps={{
                                  variant: "body2",
                                  noWrap: true,
                                  textTransform: "capitalize",
                                }}
                              />
                            </ListItem>

                            <ListItem disablePadding>
                              <ListItemIcon sx={{ minWidth: 32 }}>
                                <AssignmentIndIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText
                                primary={b.assigned_staff_name || "Not Assigned"}
                                secondary={b.assigned_staff_phone || ""}
                                primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}
                                secondaryTypographyProps={{ fontSize: 11 }}
                              />
                            </ListItem>
                          </List>

                          <Divider sx={{ my: 0.5 }} />

                          {/* Payment */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <Typography variant="body2" color="text.secondary">
                              Amount
                            </Typography>

                            <Typography variant="h6" color="#006D77" fontWeight="bold">
                              ₹{b.amount_due?.toLocaleString() || "-"}
                            </Typography>
                          </Box>

                          {/* Actions */}
                              <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                          <Stack direction="row" spacing={0.5} flexWrap="wrap">
                            <Tooltip title="View Details">
                              <IconButton
                                size="small"
                                onClick={() => setViewBkg(b)}
                                sx={{
                                  color: "#006D77",
                                  bgcolor: alpha("#006D77", 0.08),
                                  "&:hover": { bgcolor: alpha("#006D77", 0.16) },
                                }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            {b.status === "completed" && b.payment_status !== "paid" && (
                              <>
                                <Tooltip title="Set Payment Amount">
                                  <IconButton
                                    size="small"
                                    onClick={() => setAmountDlg({ open: true, booking: b })}
                                    sx={{
                                      color: "#16a34a",
                                      bgcolor: alpha("#16a34a", 0.08),
                                    }}
                                  >
                                    <CurrencyRupeeIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title="Mark Cash Paid">
                                  <IconButton
                                    size="small"
                                    onClick={() => setCashPaidDlg({ open: true, booking: b })}
                                    sx={{
                                      color: "#d97706",
                                      bgcolor: alpha("#d97706", 0.08),
                                    }}
                                  >
                                    <PaymentIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}

                            {(b.status === "pending" || b.status === "confirmed") && (
                              <Tooltip title="Assign Staff">
                                <IconButton
                                  size="small"
                                  onClick={() => setAssignDlg({ open: true, booking: b })}
                                  sx={{
                                    color: "#7c3aed",
                                    bgcolor: alpha("#7c3aed", 0.08),
                                  }}
                                >
                                  <PersonAddIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}

                            {b.status === "pending" && (
                              <Tooltip title="Confirm">
                                <IconButton
                                  size="small"
                                  color="success"
                                  onClick={() => handleStatus(b._id, "confirmed")}
                                >
                                  <CheckCircleIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}

                            {b.status === "confirmed" && (
                              <Tooltip title="Complete">
                                <IconButton
                                  size="small"
                                  color="success"
                                  onClick={() => setCompleteDlg({ open: true, booking: b })}
                                >
                                  <TaskAltIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}

                            {(b.status === "pending" || b.status === "confirmed") && (
                              <Tooltip title="Cancel">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleStatus(b._id, "cancelled")}
                                >
                                  <CancelIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Stack>
                          {b.status === "completed" && (
                          <Stack spacing={0.5} alignItems="flex-end">
                                <PaymentChip value={b.payment_status} paymentId={b.payment_id} />
                            </Stack>)}
                            </Box>
                        </CardContent>
                      </Card>
                       </Grid>
                    );
                  })}
                </Grid>)}
                          <PaginationBar page={page} totalPages={totalPages} onPageChange={setPage}
                total={total} pageSize={PAGE_SIZE} label="bookings" />
            </Paper>
          )}
        </Container>
      </Box>

      {/* ── View dialog ── */}
      <BookingViewDialog
        booking={viewBkg}
        onClose={() => setViewBkg(null)}
        onStatus={(id, status) => { handleStatus(id, status); setViewBkg(null); }}
        onAssign={b => { setViewBkg(null); setAssignDlg({ open: true, booking: b }); }}
        onComplete={b => { setViewBkg(null); setCompleteDlg({ open: true, booking: b }); }}
        onUploadAgreement={b => { setViewBkg(null); setAgreementDlg({ open: true, booking: b }); }}
        onViewDocument={setViewDocUrl}
        onUpdateSession={(b, s) => { setViewBkg(null); setSessionDlg({ open: true, booking: b, session: s }); }}
        onAddSession={(b) => { setViewBkg(null); setSessionDlg({ open: true, booking: b, session: null }); }}
      />

      {/* ── Assign staff dialog ── */}
      <AssignStaffDialog
        open={assignDlg.open}
        booking={assignDlg.booking}
        onClose={() => setAssignDlg({ open: false, booking: null })}
        onAssigned={fetchBookings}
        notify={notify}
      />

      {/* ── Completion dialog ── */}
      <CompletionDialog
        open={completeDlg.open}
        booking={completeDlg.booking}
        onClose={() => setCompleteDlg({ open: false, booking: null })}
        onCompleted={(updatedBooking) => {
          if (updatedBooking) updateBookingInState(updatedBooking);
          else fetchBookings();
        }}
        notify={notify}
      />

      {/* ── Staff management dialog ── */}
      <StaffManagementDialog
        open={staffMgmtOpen}
        onClose={() => setStaffMgmtOpen(false)}
        notify={notify}
      />

      <SetAmountDialog
        open={amountDlg.open}
        booking={amountDlg.booking}
        onClose={() => setAmountDlg({ open: false, booking: null })}
        onSaved={(updatedBooking) => {
          if (updatedBooking) updateBookingInState(updatedBooking);
          else fetchBookings();
        }}
        notify={notify}
      />
      <MarkCashPaidDialog
        open={cashPaidDlg.open}
        booking={cashPaidDlg.booking}
        onClose={() => setCashPaidDlg({ open: false, booking: null })}
        onSaved={(updatedBooking) => {
          if (updatedBooking) updateBookingInState(updatedBooking);
          else fetchBookings();
        }}
        notify={notify}
      />
      <UploadAgreementDialog
        open={agreementDlg.open}
        booking={agreementDlg.booking}
        onClose={() => setAgreementDlg({ open: false, booking: null })}
        onSaved={(updatedBooking) => {
          if (updatedBooking) updateBookingInState(updatedBooking);
          else fetchBookings();
        }}
        notify={notify}
      />
 <DocumentViewerDialog url={viewDocUrl} onClose={() => setViewDocUrl(null)} />
      <SessionUpdateDialog
        open={sessionDlg.open}
        booking={sessionDlg.booking}
        session={sessionDlg.session}
        onClose={() => setSessionDlg({ open: false, booking: null, session: null })}
        onSaved={(updatedBooking) => {
          if (updatedBooking) updateBookingInState(updatedBooking);
          else fetchBookings();
        }}
        notify={notify}
      />

      {/* ── Snackbar ── */}
      <Snackbar open={snack.open} autoHideDuration={3000}
        onClose={() => setSnack(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
        <Alert severity={snack.sev} variant="filled"
          onClose={() => setSnack(s => ({ ...s, open: false }))}
          sx={{ borderRadius: 2, fontWeight: 600 }}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}